<div [ngSwitch]="loaderType">
  <app-company-loader
    *ngSwitchCase="'company-loader'"
    class="loader">
  </app-company-loader>

  <app-spinner-loader
    *ngSwitchCase="'spinner'"
    class="loader"
    [diameter]="diameter"
    [stroke]="stroke">
  </app-spinner-loader>

  <app-spinner-loader
    *ngSwitchDefault
    class="loader"
    [diameter]="diameter"
    [stroke]="stroke">
  </app-spinner-loader>
</div>


